import { guardedCustomElement } from '../utils/guarded-custom-element';
import { SDSTextComponent } from './sds-text.component';

@guardedCustomElement('sds-text')
export class SDSText extends SDSTextComponent {}

declare global {
	interface HTMLElementTagNameMap {
		'sds-text': SDSText;
	}
}
